import { useMutation, useQuery } from "react-query";
import {
	change_password_api,
	get_user_by_id_api,
	updatefullname,
	updatePhoneNumber,
	getCountryCodes,
	logout,
} from "../services/profile";

export const useGetUserDataById = (id) =>
	useQuery(["getUserDataById", id], () => get_user_by_id_api(id));

export const usechangePassword = () =>
	useMutation("changePassword", (body) => change_password_api(body));

export const useUpdateFullName = () =>
	useMutation("updateFullName", (body) => updatefullname(body));

export const useUpdatePhoneNumber = () =>
	useMutation("UpdatePhoneNumber", (body) => updatePhoneNumber(body));

export const useCountryCodes = () =>
	useQuery(["countryCodes"], () => getCountryCodes());

export const uselogout = () => useMutation("logout", () => logout());
